<template>
  <div class="md-layout-item md-size-100 my-2">
    <ContentSkeleton v-if="isLoading" variant="cards" :rows="3" />
    <div
      class="w-100 text-center customborder"
      v-if="activitiesWithDate.length == 0 && !isLoading"
    >
      <h5 class="text-secondary p-4">{{ $t("nothingtosee") }}</h5>
    </div>
    <!-- Listado de actividades con startDate no nulo -->
    <div v-if="activitiesWithDate.length">
      <div
        v-for="act in activitiesWithDate"
        class="card p-4"
        :class="isPastDay(act.startDate) ? 'bg-grey' : ''"
      >
        <div class="d-inline">
          <span class="text-secondary" v-if="act.startDate"
            >{{ labelDate(act.startDate) }} {{ act.startTime }}hs.</span
          >
          <Activity :myclasses="true" :activity="act" :edit="false" />
          <button
            class="md-button md-danger md-sm"
            v-if="!isPastDay(act.startDate) && isClientGym()"
            @click="deleteClass(act._id, act.startDate)"
            >{{ $t("unsubscribe") }}</button
          >
        </div>
      </div>
    </div>

    <!-- Listado de actividades con startDate nulo -->
    <div v-if="activitiesWithoutDate.length">
      <div v-for="act in activitiesWithoutDate" class="card p-4">
        <div class="d-inline">
          <Activity :myclasses="true" :activity="act" :edit="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import permissionsMixin from "@/mixins/permissionsMixin";
import ContentSkeleton from "@/components/common/ContentSkeleton.vue";
import Swal from "sweetalert2";
import { format, isBefore, isToday } from "date-fns";
// Mock component to replace non-existent import
const Activity = {
  template: "<div>Activity component not available</div>",
  name: "Activity",
};

// Mock functions to replace non-existent imports
const deleteClassAction = async (id) => {
  console.warn(
    "deleteClassAction is not available - Stablishments actions module was removed"
  );
  return { success: false, message: "Delete class not available" };
};

const getMyClassesAction = async () => {
  console.warn(
    "getMyClassesAction is not available - Stablishments actions module was removed"
  );
  return { success: false, data: [] };
};

export default {
  name: "myclasses",
  mixins: [permissionsMixin],
  components: {
    Activity,
    ContentSkeleton,
  },
  data() {
    return {
      isLoading: false,
      activitiesWithDate: [], // Actividades con startDate no nulo
      activitiesWithoutDate: [], // Actividades con startDate nulo
      daysOfWeek: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ],
    };
  },
  props: {
    all: Boolean,
    owner: Boolean,
  },
  created() {
    this.getMyClasses();
  },
  methods: {
    isPastDay(day) {
      if (!day) {
        return false;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const localDate = new Date(day);
      localDate.setHours(0, 0, 0, 0);
      return isBefore(localDate, today);
    },
    isTodayDay(day) {
      const localDate = new Date(day);
      localDate.setHours(0, 0, 0, 0);
      return isToday(localDate);
    },
    async deleteClass(id, day) {
      if (this.isTodayDay(day) && !this.isGym()) {
        Swal.fire({
          title: "No puedes cancelar ahora",
          text: "Lo sentimos pero falta muy poco para que comience esta clase. Contactate con nosotros.",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: false,
          confirmButtonColor: "#3085d6",
        }).then((result) => {});

        return;
      }

      await deleteClassAction(id);
      this.$emit("deleted");
    },
    labelDate(startDate) {
      return (
        format(startDate, "d") +
        " " +
        this.$t(format(startDate, "MMMM")) +
        " " +
        format(startDate, "yyyy")
      );
    },
    async getMyClasses() {
      this.isLoading = true;
      const response = await getMyClassesAction();

      // Filtrar actividades según si tienen o no startDate
      this.activitiesWithDate = response.data.filter((act) => act.startDate);
      this.activitiesWithoutDate = response.data.filter(
        (act) => !act.startDate
      );

      this.isLoading = false;
    },
  },
};
</script>

<style>
.bg-grey {
  background: #c8c8c8;
}
</style>
